import { Outlet } from "react-router-dom";

import { navigation } from "@src/shared/navigation";
import { ActorProvider } from "@src/shared/providers/actorProvider";

export default function AuthenticatedLayout() {
  return (
    <ActorProvider loginUrl={navigation.login}>
      <Outlet />
    </ActorProvider>
  );
}
